import React, { useEffect, useState } from 'react';
import axios from 'axios';
// import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles, CardContent, Grid, FormControl, InputLabel, Select, Card, Typography } from '@material-ui/core';
import { useSelector } from 'react-redux';
// import Layout from '../../invoices/common/Layout';
import PaymentTable from '../PaymentTable/PaymentTable';
import { CommonConfig } from '../../../config/common-config';
import SearchBox from '../../../components/table/SearchBox';
import token from '../../../config/token';
import LoaderPopUp from '../../../components/loaderpopup/loader';
// import moment from 'moment';
import Button from '@material-ui/core/Button';
import { useHistory } from 'react-router';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(6),
    },
    noRecord: {
        display: 'flex',
        justifyContent: 'center',
        background: '#f6f6f6',
        margin: '16px',
        '& h1': {
            alignSelf: 'center',
            color: 'grey',
            fontFamily: 'Rubik',
            fontSize: '14px',
            fontWeight: '400',
        },
    },
}));

function AdminPaymentHistory() {
    const tokens = token();
    const history = useHistory();
    const [selectedImc, setselectedImc] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [AllImcs, setAllImcs] = useState([]);
    const [rows, setTotalReactPackages] = useState([]);
    const [handleGeneratedReceipt, setHandleGeneratedReceipt] = useState([]);
    const [showBtnLoader, setShowBtnLoader] = useState(false);
    const [handleGeneratedReceiptError, setHandleGeneratedReceiptError] = useState('');
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const userTeam = userDetails.result && userDetails.result.data.features[0].team;
    const userDomain = userDetails.result && userDetails.result.config.data;
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const [searchData, setSearchData] = useState([]);
    const [page, setPage] = useState(0);
    const [pageDetails, setPageDetails] = useState('');
    const [loading, setLoading] = useState(false);
    const [previousButton, setpreviousButton] = useState(false);
    const [nextButton, setnextButton] = useState(false);
    const headcells = [
        // { id: 'intClientName', label: 'Name' },
        {
            id: 'invoiceId',
            label: 'Invoice Number',
            isConcat: 'true',
            concatElem: ['invoiceNumber'],
        },
        {
            id: 'invoiceId',
            label: 'Invoice Date',
            isConcat: '',
            concatElem: ['invoiceDate'],
            // date: 'true'
        },
        {
            // id: 'invoiceId',
            id: 'paymentAmount',
            label: 'Invoice amount',
            // isConcat: 'true',
            // concatElem: ['total'],
        },
        {
            id: 'razorpayPaymentId',
            label: 'Reference Number'
        },
        {
            id: 'paymentDate',
            label: 'Amount Remitted On',
            date: 'true'
        },
        {
            id: 'comments',
            label: 'Comments',
        },
    ];

    function formatDate(props) {
        return props.map((element) => {
            // console.log("element", element);
            // const tempEndDate = element.dateModified;
            const tempPaymentDate = element.paymentDate;
            // element.dateModified = tempEndDate.split(' ', 1);
            element.paymentDate = tempPaymentDate.split(' ', 1);
        });
    }

    useEffect(() => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/s-int-clients`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => setAllImcs(response.data.content))
            .catch((error) => {
            });

        if (searchQuery && searchQuery.length > 2) {
            getSearchValue(searchQuery);
        } else {
            setSearchData([]);
            getTotalPackages();
        }

        if (userTeam != "ITeC Team") {
            if (userDomain) {
                let JsonUserDomain = JSON.parse(userDomain)
                ////console.log("userDomain",JsonUserDomain.tennantName);
                setImc(JsonUserDomain.tennantName);
            }
        }
    }, [handleGeneratedReceipt, tokens]);

    const getTotalPackages = () => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/payment-history-int-clients/${selectedImc}?page=${page}&size=10&sort=paymentId,desc`, tokens)
            .then((response) => {
                // console.log('response------123', response);
                formatDate(response.data.content);
                setTotalReactPackages(response.data.content);
                setPageDetails(response.data);
                setLoading(false);
                if (response.data.first) {
                    // console.log('first');
                    setpreviousButton(true);
                    setnextButton(false);
                } else if (response.data.last) {
                    // console.log('last');
                    setpreviousButton(false);
                    setnextButton(true);
                } else {
                    setpreviousButton(false);
                    setnextButton(false);
                }
            })
            .catch((error) => {
            });
    }

    const handleCount = (val) => {
        if (val === 'prev') {
            if (pageDetails.first !== true) {
                setPage((page) => page - 1);
            }
        }

        if (val === 'next') {
            if (pageDetails.last !== true) {
                setPage((page) => page + 1);
            }
        }
    };

    const getSearchValue = (data) => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/payment-history-int-clients/${selectedImc}?search=${data}&page=${page}&size=10&sort=paymentDate,desc`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((res) => {
                // console.log('responseresponse11', res);
                if (res.data) {
                    if (res.data.content.length === 0) {
                        setTotalReactPackages([]);
                    }
                    formatDate(res.data.content);
                    setSearchData(res.data.content);
                    setPageDetails(res.data);
                    setLoading(false);
                    if (res.data.first) {
                        // console.log('first');
                        setpreviousButton(true);
                        setnextButton(false);
                    } else if (res.data.last) {
                        // console.log('last');
                        setpreviousButton(false);
                        setnextButton(true);
                    } else {
                        setpreviousButton(false);
                        setnextButton(false);
                    }
                }
            })
            .catch((error) => {
            });
    }

    const allImcsOptions = (vv) => {
        const OptionList = vv.map((data) => <option value={data.dbName}>{data.dbName}</option>);
        return OptionList;
    };

    const handleGenerateReceipt = (data) => {
        setShowBtnLoader(true);
        if (data.paymentId) {
            axios
                .post(`${CommonConfig.dev.baseUrl}/api/auth/generate-receipt/${selectedImc}/${data.paymentId}`)
                .then((response) => {
                    setHandleGeneratedReceipt(response.data.content);
                    setShowBtnLoader(false);
                })
                .catch((error) => {
                    const errResult = error.response;
                    if (errResult.data) {
                        const errorMsg = errResult.data;
                        setTimeout(() => {
                            setShowBtnLoader(false);
                        }, 2000);
                        setHandleGeneratedReceiptError(errorMsg.message);
                    }
                });
        }
    };

    // search Query
    const handleSearchQuery = (searchData) => {
        setSearchQuery(searchData);
        if (searchData && searchData.length > 2) {
            getSearchValue(searchData);
            return true;
        }
        if (!searchData) {
            setSearchData([]);
            getTotalPackages();
        }
    };

    const clearField = () => {
        setSearchQuery('');
        setSearchData([]);
        getTotalPackages()
    }

    const setImc = (e) => {
        let imc = '';
        if (e.target) {
            imc = e.target.value;
        }
        else {
            imc = e;
        }
        setselectedImc(imc);
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/payment-history-int-clients/${imc}?page=0&size=1000&sort=paymentId,desc`, tokens)
            .then((response) => {
                formatDate(response.data.content);
                setTotalReactPackages(response.data.content);
                setPageDetails(response.data);
                setLoading(false);
                if (response.data.first) {
                    setpreviousButton(true);
                    setnextButton(false);
                } else if (response.data.last) {
                    setpreviousButton(false);
                    setnextButton(true);
                } else {
                    setpreviousButton(false);
                    setnextButton(false);
                }
            })

            .catch((error) => {
            });
    };

    const filteredRow = searchData && searchData.length ? searchData : rows;
    const classes = useStyles();
    const back = () => {
        history.push({
            pathname: '/menu',
        })
    };
    return (
        <>

            {(showBtnLoader && (
                <div>
                    <LoaderPopUp showLoader={showBtnLoader} />
                    {/* <div style={{ position: 'relative', top: 300, left: 700 }}>
                        <span style={{ position: 'absolute', top: 20 }}>Loading......</span>
                        <CircularProgress style={{ color: '#F8951B' }} size={20} />
                    </div> */}
                    <div style={{ position: 'absolute', top: 300, left: 700 }}>
                        <span> {handleGeneratedReceiptError} </span>
                    </div>
                </div>
            ))

                ||
                <div className={classes.root}>
                    {userTeam === "ITeC Team" ? (
                        <CardContent>
                            <Grid spacing={3} className="main-container">
                                <Grid item xs={12} sm={12} style={{ paddingLeft: '0' }}>
                                    <FormControl fullWidth>
                                        <InputLabel className="lbl" htmlFor="selectimc" shrink>
                                            Select IMC
                                        </InputLabel>
                                        <Select native className="bottom" name="intclientName" onChange={setImc} value={selectedImc}>
                                            <option value="" selected disabled hidden>Select IMC</option>
                                            {allImcsOptions(AllImcs)}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </CardContent>
                    ) : ('')}

                    <Card className="custom-table">
                        <CardContent className="card-title-display">
                            <Grid item xs={12} sm={8}>
                                <Typography className="card-title">Payment History</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} className="card-search">
                                <div className="search-field">
                                    <SearchBox searchQuery={searchQuery} onChange={handleSearchQuery} clearField={clearField} placeholder="Search..." />
                                </div>
                            </Grid>
                        </CardContent>
                        <CardContent className="card-table-display">
                            {rows && filteredRow.length > 0 ? (
                                <>
                                    <PaymentTable
                                        headcells={headcells}
                                        rows={filteredRow}
                                        // pageName="admin"
                                        handleGenerateReceipt={handleGenerateReceipt}
                                        handleCount={handleCount}
                                        pageDetails={pageDetails}
                                        loading={loading}
                                        prvnxtbt={{ prvBt: previousButton, nxtBt: nextButton }}
                                        attachment />
                                </>
                            ) : (
                                    <div className={classes.noRecord}>
                                        <h1>No records to display</h1>
                                    </div>
                                )}
                        </CardContent>
                    </Card>

                    {/* <div className="itec-textboxes">
                        Select IMC
                <select className="intclientName intSelect" name="intclientName" onChange={setImc} value={selectedImc}>
                            <option value="" selected disabled hidden>Select IMC</option>
                            {allImcsOptions(AllImcs)}
                        </select>
                    </div>
                    <Layout title="Payment History" searchQuery={searchQuery} onChange={handleSearchQuery} className={classes} />
                    {filteredRow.length === 0 && <span style={{ fontSize: '14px', fontWeight: '500' }}>No records found to display!</span>}
                    <PaymentTable
                        headcells={headcells}
                        rows={filteredRow}
                        pageName="admin"
                        handleGenerateReceipt={handleGenerateReceipt}
                        action attachment /> */}
                </div>
            }
            <Button variant="contained" onClick={() => back()} className="btnBlue txt-cap btnBckFloat" color="primary">
                Back
  </Button>
        </>
    );
}

export default AdminPaymentHistory;
